import { VStack as ChakraVStack, type StackProps } from '@chakra-ui/react';

/**
 * Renders VStack with our preferred defaults
 *
 * @see https://github.com/chakra-ui/chakra-ui/blob/main/packages/react/src/components/stack/stack.tsx#L67
 *
 * @default align "start"
 * @default gap 4
 * @default width "full"
 */
export const VStack = ({
  alignItems = 'start',
  gap = 4,
  width = 'full',
  ...rest
}: StackProps) => (
  <ChakraVStack alignItems={alignItems} gap={gap} width={width} {...rest} />
);
